export default "__VITE_ASSET__3cf4ca7c__"